module.exports = __webpack_public_path__ + "media/images/landings/promotion_4/ogp2-0f73966d52b08ddd166d331f8499f07d.png";